import React, { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";

export default function AdminPage() {
    const [guides, setGuides] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;

    // Initialize EmailJS
    useEffect(() => {
        emailjs.init("ZOyRJm9HRzFURhE8Z");
    }, []);

    // Fetch pending guides
    const fetchGuides = async () => {
        try {
            const res = await fetch(`${API_URL}/guides/pending`);
            const data = await res.json();
            setGuides(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Error fetching guides:", err);
            setGuides([]);
        }
    };

    useEffect(() => {
        fetchGuides();
    }, []);

    // Approve guide
    const handleApproval = async (guideId, guideEmail, guideName, guidePassword, status) => {
        try {
            // Update guide approval status
            await fetch(`${API_URL}/guides/${guideId}/approve`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ isApproved: status }),
            });

            // Prepare approval email
            const subject = "We are thrilled to announce you as approved as guide!";
            const message = `Hello ${guideName},

Congratulations! Your registration as a guide has been approved.

You can now login using the following credentials:
Email: ${guideEmail}
Password: ${guidePassword}
Login here: https://soulful-yatra-updated.netlify.app/

We are excited to onboard you and look forward to amazing journeys together!

Best regards,
Soulful Yatra Team`;

            // Send approval email
            sendEmail(guideEmail, subject, message);

            fetchGuides(); // Refresh guide list
        } catch (err) {
            console.error("Error updating guide:", err);
        }
    };

    // Reject guide
    const handleReject = async (guideId, guideEmail, guideName) => {
        try {
            const confirmReject = window.confirm("Are you sure you want to reject this guide?");
            if (!confirmReject) return;

            // Prepare rejection email
            const subject = "Regarding your guide registration on Soulful Yatra";
            const message = `Hello ${guideName},

We appreciate your interest in joining Soulful Yatra as a guide.

After careful review, we regret to inform you that your registration has not been approved at this time.

Thank you for your understanding, and we hope to collaborate with you in the future.

Best regards,
Soulful Yatra Team`;

            // Send rejection email
            await sendEmail(guideEmail, subject, message);

            // Delete the guide from DB
            const res = await fetch(`${API_URL}/guides/${guideId}/reject`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
            });

            if (res.ok) {
                alert("Guide rejected and email sent successfully!");
                fetchGuides(); // Refresh list
            } else {
                const data = await res.json();
                alert("Failed to reject guide: " + data.error);
            }
        } catch (err) {
            console.error("Error rejecting guide:", err);
            alert("An error occurred while rejecting the guide.");
        }
    };

    // Email sender function
    const sendEmail = (email, subject, message) => {
        emailjs
            .send("service_vwckm3m", "template_z0yrbwk", { email, subject, message })
            .then((response) => console.log("Email sent:", response))
            .catch((error) => console.error("Email sending error:", error));
    };

    return (
        <div style={{ padding: "20px", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
            <h1 style={{ textAlign: "center", color: "#4f46e5", marginBottom: "20px" }}>
                Admin – Pending Guide Registrations
            </h1>

            <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "white" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#e0e7ff", color: "#1e293b" }}>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Name</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Email</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Phone</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Places</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Languages</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Base Fare</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Fare Type</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Govt Certificate</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Status</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {guides.length ? (
                            guides.map((guide) => (
                                <tr key={guide._id} style={{ borderBottom: "1px solid #ddd" }}>
                                    <td style={{ padding: "10px" }}>{guide.name}</td>
                                    <td style={{ padding: "10px" }}>{guide.email}</td>
                                    <td style={{ padding: "10px" }}>{guide.phone}</td>
                                    <td style={{ padding: "10px" }}>{guide.places.join(", ")}</td>
                                    <td style={{ padding: "10px" }}>
                                        {guide.languages?.length ? guide.languages.join(", ") : "N/A"}
                                    </td>
                                    <td style={{ padding: "10px" }}>₹{guide.baseFare}</td>
                                    <td style={{ padding: "10px" }}>{guide.fareType}</td>
                                    <td style={{ padding: "10px", textAlign: "center" }}>
                                        {guide.govtCertificatePublicId ? (
                                            <a
                                                href={`${API_URL}/guides/${guide._id}/certificate`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: "none", fontSize: "20px" }}
                                            >
                                                👁️
                                            </a>
                                        ) : (
                                            "N/A"
                                        )}
                                    </td>
                                    <td
                                        style={{
                                            padding: "10px",
                                            color: guide.isApproved ? "green" : "red",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {guide.isApproved ? "Approved" : "Pending"}
                                    </td>
                                    <td style={{ padding: "10px" }}>
                                        {!guide.isApproved && (
                                            <>
                                                <button
                                                    onClick={() =>
                                                        handleApproval(
                                                            guide._id,
                                                            guide.email,
                                                            guide.name,
                                                            guide.tempPassword || "your_password",
                                                            true
                                                        )
                                                    }
                                                    style={{
                                                        backgroundColor: "#22c55e",
                                                        color: "white",
                                                        padding: "5px 10px",
                                                        borderRadius: "6px",
                                                        border: "none",
                                                        cursor: "pointer",
                                                        marginRight: "5px",
                                                    }}
                                                >
                                                    Approve
                                                </button>
                                                <button
                                                    onClick={() => handleReject(guide._id, guide.email, guide.name)}
                                                    style={{
                                                        backgroundColor: "#ef4444",
                                                        color: "white",
                                                        padding: "5px 10px",
                                                        borderRadius: "6px",
                                                        border: "none",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Reject
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ textAlign: "center", padding: "10px" }}>
                                    No pending guides
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
